<script setup lang="ts">
  import { useFormField } from '@/composables/useFormField'

  const props = defineProps({
    field: {
      type: Object,
      default: null
    }
  })

  useFormField(props)
</script>

<template>
  <div class="info-block">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="props.field.text" />
  </div>
</template>
